import {Component, Inject, Input, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {ActionResult, EventItem, EventRaceItem} from "@model";
import {getLanguageValue} from "@utility";
import {TranslocoService} from "@ngneat/transloco";
import {
  AuthenticationService,
  EventRaceService,
  EventService, LoaderService,
  TOAST_STATE, ToastService
} from '@services';
import {LOGIN_ROUTE} from 'src/app/app-routing.module';
import {Router} from '@angular/router';
import {NgbOffcanvas} from '@ng-bootstrap/ng-bootstrap';
import {AbstractComponent} from '../abstract.component';
import {DOCUMENT} from "@angular/common";
import {environment} from "@environment";

@Component({
  selector: 'app-share-favourite-cta',
  templateUrl: './share-favourite-cta.component.html',
  styleUrls: ['./share-favourite-cta.component.scss']

})
export class ShareFavouriteCtaComponent extends AbstractComponent implements OnInit {
  @Input() eventItem?: EventItem;
  @Input() isPreviewComponent?: boolean;
  isShareVisible: boolean = false;
  label?: string;
  description?: string;

  constructor(private titleService: Title, private metaService: Meta, private translocoService: TranslocoService,
              private authenticationService: AuthenticationService, private router: Router, private offcanvasService: NgbOffcanvas,
              private eventService: EventService, private eventRaceService: EventRaceService,
              private toastService: ToastService, private loaderService: LoaderService,
              @Inject(DOCUMENT) public document: Document) {
    super();
  }

  ngOnInit(): void {
    if (this.eventItem) {
      this.label = getLanguageValue(this.eventItem.name, this.eventItem.nameEng, this.eventItem.nameIta, this.eventItem.nameSlo, this.translocoService.getActiveLang()) ?? "";
      this.description = getLanguageValue(this.eventItem.description, this.eventItem.descriptionEng, this.eventItem.descriptionIta, this.eventItem.descriptionSlo, this.translocoService.getActiveLang()) ?? "";
      this.setSEOData(this.label, this.description);
      this.isShareVisible = true;
    }
  }

  addToFavoritesButtonClicked(): void {
    if(this.isPreviewComponent){
      return;
    }else{
      if (this.authenticationService.isAuthenticated()) {
        this.addToFavoritesAction();
      } else {
        this.toastService.showToast(TOAST_STATE.warning, this.translocoService.translate("event.favorite.save.warning"));
      }
    }
  }

  addToFavoritesAction(): void {
    this.loaderService.startLoading()
    if (this.eventItem?.favorite) {
      this.eventService.removeEventFromFavorites(this.eventItem?.id).subscribe((actionResult: ActionResult<boolean>) => {
        if (actionResult.result) {
          this.eventRaceService.fetchUserFavoritesEventRaces().subscribe((_: EventRaceItem[]) => {
            this.loaderService.dismissLoading();
          });
          this.eventItem!.favorite = false;
        } else {
          this.loaderService.dismissLoading();
        }
      });
      this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate("event.favorite.delete.success"));
    } else {
      this.eventService.addEventToFavorites(this.eventItem!.id!).subscribe((actionResult: ActionResult<boolean>) => {
        if (actionResult.result) {
          this.eventRaceService.fetchUserFavoritesEventRaces().subscribe((_: EventRaceItem[]) => {
            this.loaderService.dismissLoading();
          });
          this.eventItem!.favorite = true;
        } else {
          this.loaderService.dismissLoading();
        }
      });
      this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate("event.favorite.save.success"));
    }
  }

  goToLogin(): void {
    this.offcanvasService.dismiss();
    this.router.navigate([LOGIN_ROUTE]);
  }

  setSEOData(title: string, description: string): void {
    this.titleService.setTitle(title);
    this.metaService.addTag({property: 'og:title', content: title});
    this.metaService.addTag({property: 'og:description', content: description});
    this.metaService.addTag({property: 'og:url', content: this.document.location.href});
    this.metaService.addTag({property: 'og:type', content: 'website'});
    this.metaService.addTag({property: 'og:site_name', content: environment.site_name});
    this.metaService.addTag({property: 'og:image', content: this.eventItem?.imageIcon ?? ''});
  }
}
